// Auto-generated by build-env.js, do not edit manually.
export const BUILD_INFO = {
  "VERSION": "v.2026.1105.16.45",
  "VER_USER": "yuese.sun",
  "VER_COMMIT": "074fcac4e51db4f4c355081c169962e76125ff36",
  "BUILD_TIME": "2026-11-05 16:45:15"
};
